import { enCA, enUS, enAU, enGB, enNZ } from "date-fns/locale";

const MONTH_FIRST_FORMATS = {
  matchDate: "EEE MMM do", // "Wed Jan 29th"
  arrivalDate: "MMM do", // "Jan 29th"
  fullDateTime: "MMM do yyyy, h:mm a",
  longDate: "MMMM d, yyyy",
  tagDate: "EEEEEE MMM do", // "Th Jan 29th"
};

const DAY_FIRST_FORMATS = {
  matchDate: "EEE d MMM", // "Wed 29 Jan"
  arrivalDate: "d MMM", // "29 Jan"
  fullDateTime: "d MMM yyyy, h:mm a",
  longDate: "d MMMM yyyy",
  tagDate: "EEEEEE d MMM", // "Th 29 Jan"
};

export const LOCALE_CONFIG = {
  "en-CA": { dateFnsLocale: enCA, formats: MONTH_FIRST_FORMATS },
  "en-US": { dateFnsLocale: enUS, formats: MONTH_FIRST_FORMATS },
  "en-AU": { dateFnsLocale: enAU, formats: DAY_FIRST_FORMATS },
  "en-GB": { dateFnsLocale: enGB, formats: DAY_FIRST_FORMATS },
  "en-NZ": { dateFnsLocale: enNZ, formats: DAY_FIRST_FORMATS },
};

export const MONTH_FIRST_LOCALES = ["en-CA", "en-US"];
export const DAY_FIRST_LOCALES = ["en-AU", "en-GB", "en-NZ"];

export function isMonthFirst(locale) {
  return MONTH_FIRST_LOCALES.includes(locale);
}
